import React, { useState } from "react";
import BtnSlider from "./BtnSlider";
import backgroundGradient from "./Gradients/Background.svg";
// import iconColon from "./Gradients/sectionTwelveIcon.svg";
import { useEffect } from "react";
import fetchPastExperience from "./packages/fetchPastExperience";
import EditableExperience from "../../../../Admin/AdminPastGeb/components/EditableExperience/EditableExperience";
import ImgUrlConstants from "../../../../../utils/imgUrlConstants";

export default function Slider({ id, isAdmin }) {
  const [slideIndex, setSlideIndex] = useState(1);
  const [pastExp, setPastExp] = useState([]);
  useEffect(() => {
    if (id) {
      fetchPastExperience({
        setPastExp: setPastExp,
        editionId: id,
      });
    }
  }, [id]);

  const nextSlide = () => {
    if (slideIndex !== pastExp.length) {
      setSlideIndex(slideIndex + 1);
    } else if (slideIndex === pastExp.length) {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else if (slideIndex === 1) {
      setSlideIndex(pastExp.length);
    }
  };

  useEffect(() => {
    let interval;

    if (!isAdmin) {
      interval = setInterval(() => {
        nextSlide();
      }, 8000);
    }

    return () => clearInterval(interval);
  }, [slideIndex, isAdmin]);

  // console.log("pexp = ", pastExp)
  return (
    <div
      className="container-slider"
      style={{
        backgroundImage: `url(${backgroundGradient})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div style={{ position: "relative", marginRight: "8rem" }}>
        {
          isAdmin ?
            <EditableExperience
              title={"Add New Experience"}
              id={id}
              isActionCreate={true}
            />
            : ""
        }
      </div>
      {pastExp.map((obj, index) => {
        if (slideIndex == index + 1)
          return (
            <div key={index}
              className={slideIndex === index + 1 ? "slide active-anim" : "slide"}
            >
              {
                isAdmin ?
                  <EditableExperience
                    title={"Edit"}
                    id={obj._id}
                    pname={obj.name}
                    feedback={obj.feedback}
                    paddress={obj.address}
                  />
                  : ""
              }
              <div className="container_slider_top">
                <div className="container_slider_top_header">
                  GEB <span style={{ color: "black" }}
                    className="p_color"
                  >Experience</span>
                </div>
                <span className="container_quote">"</span>
              </div>
              <div className="container_slider_body">
                <p className="container_slider_body_content">{obj.feedback}</p>
              </div>
              <div className="container_slider_body_lower">
                <img
                  src={`${ImgUrlConstants.PAST_GEB_EXPERIENCE_PIC}/${obj._id}.png`}
                  className="container_slider_body_image"
                  alt=""
                />
                <div className="container_slider_body_lower_text">
                  <span className="container_slider_body_name">{obj.name}</span>
                  <span className="container_slider_body_subtext">
                    {obj.address}
                  </span>
                </div>
              </div>
            </div>
          );
      })}
      <BtnSlider moveSlide={nextSlide} direction={"next"} />
      <BtnSlider moveSlide={prevSlide} direction={"prev"} />
    </div>
  );
}
